import { css } from 'styled-components';

const buttonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  width:100%;
  height: ${props => props.size == "medium" ? "35px" : "45px"};
  margin: 0 auto;
  text-decoration: none;
  border-radius: ${props => props.size == "medium" ? "4px" : "6px"};
  -webkit-font-smoothing: antialiased;
  -webkit-touch-callout: none;
  user-select: none;
  cursor: pointer;
  outline: 0;
  font-family:'Montserrat';
  font-weight: 600;
  font-size: ${props => props.size == "medium" ? "14px" : "16px"};
  letter-spacing:0px;
  border: 0;
  background-color:${props => props.color.normal};
  box-shadow:4px 3px 6px 1px #CFCFCF;
  color: ${props => props.color.font};
  transition: background-color 0.3s;

  &:hover {
    background-color:${props => props.color.light};
    color: ${props => props.color.font_light};
  }

  @media (min-width: 280px) {
    box-shadow:4px 3px 6px 1px #CFCFCF;
    line-height:2.7em;
    font-size: ${props => props.size == "medium" ? "16px" : "18px"};
    height: 50px;
  }
`;

export default buttonStyles;
